import styled from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import theme from 'styles/theme'
import { Body20, Title60, Body12, Title26 } from 'components/Typography'
import { Element } from 'react-scroll'
import { getBGColor } from 'utils/themeUtils'

export const Container = styled(Element)`
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const GridTitleTextCont = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: ${theme.space[5]} 0;
  max-width: 1180px;

  ${theme.mediaQueries.mobile} {
    padding: 0 ${theme.space[2]};
  }
`

export const GridTitle = styled(Title60)`
  overflow-wrap: break-word;
  width: 100%;
`

export const GridSubtitle = styled(Body20)`
  color: ${(props) => props.theme.colors.sagemedium};
`
export const SubTitleContainer = styled.div`
  text-align: center;
  padding: ${theme.space[2]} ${theme.space[2]} 0 ${theme.space[2]};
`
export const GridWrapper = styled.div`
  margin: 0 auto;
  max-width: 1180px;
  width: 100%;
  padding: 0 ${theme.space[2]};
  display: grid;
  grid-template-columns: 1fr 1fr;
  ${theme.mediaQueries.medium} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  row-gap: 1em;
  column-gap: 1em;
  margin-bottom: 40px;

  ${theme.mediaQueries.mobile} {
    column-gap: 0.2rem;
    padding: 0 0.5rem;
  }
`

export const CalloutContainer = styled.div`
  grid-row-start: ${(props) => (props.mobileRow ? props.mobileRow : 1)};
  grid-column-start: 1;
  grid-column-end: 3;
  background-color: ${getBGColor()};
  ${theme.mediaQueries.medium} {
    // HORIZONTAL
    grid-column-start: ${(props) => (props.colStart ? props.colStart : 1)};
    grid-column-end: ${(props) => (props.colEnd ? props.colEnd : 3)};
    // VERTICAL
    grid-row-start: ${(props) => (props.rowStart ? props.rowStart : 1)};
    grid-row-end: ${(props) => (props.rowEnd ? props.rowEnd : 3)};
  }
`

export const CalloutImage = styled(GatsbyImage)`
  width: 100%;
  aspect-ratio: 10 / 16;
  @supports not (aspect-ratio: 10 / 16) {
    ${(props) => `height: ${props.width * 1.6}px;`}
  }
`

export const VideoContainer = styled.div`
  width: 100%;
`
export const CalloutProductTextCont = styled.div`
  padding: ${theme.space[2]} ${theme.space[1]};
  width: 100%;
`
export const CalloutProductCaption = styled(Body12)`
  padding-bottom: ${theme.space[2]};
  color: ${theme.colors.sagedark};
`

export const CalloutProductTitle = styled(Title26)``
